export default "__VITE_ASSET__BEAFxV39__"